import {
  ProcessTemplatesTranslation,
  processTemplatesTranslation,
} from '@/assets/locales/views/admin/processTemplates/processTemplates.translation.en.ts';
import {
  AnalysisRemarksViewTranslation,
  analysisRemarksViewTranslation,
} from '@/assets/locales/views/analysisRemarks/analysisRemarks.translation.en.ts';
import {
  CandidateDetailsTranslation,
  candidateDetailsTranslation,
} from '@/assets/locales/views/candidates/details/candidateDetails.translation.en.ts';
import {
  ExperienceCompaniesTranslation,
  experienceCompaniesTranslation,
} from '@/assets/locales/views/experienceCompanies/experienceCompanies.translation.en.ts';
import {
  IntakeCallTemplatesTranslation,
  intakeCallTemplatesTranslation,
} from '@/assets/locales/views/intakeCallTemplates/intakeCallTemplates.translation.en.ts';
import {
  InterviewSimulationsTranslation,
  interviewSimulationsTranslation,
} from '@/assets/locales/views/interviewSimulations/interviewSimulations.translation.en.ts';
import {
  MaintenanceTranslation,
  maintenanceTranslation,
} from '@/assets/locales/views/maintenance/maintenance.translation.en.ts';
import {
  MeetingsViewTranslation,
  meetingsViewTranslation,
} from '@/assets/locales/views/meetings/meetings.translation.en.ts';
import {
  processesTranslation,
  ProcessesTranslation,
} from '@/assets/locales/views/processes/processes.translation.en.ts';
import {
  statisticsTranslation,
  StatisticsTranslation,
} from '@/assets/locales/views/statistics/statistics.translation.en.ts';
import {
  tagsTranslation,
  TagsTranslation,
} from '@/assets/locales/views/tags/tags.translation.en.ts';

export type ViewsTranslation = {
  analysisRemarks: AnalysisRemarksViewTranslation;
  candidates: CandidateDetailsTranslation;
  experienceCompanies: ExperienceCompaniesTranslation;
  intakeCallTemplates: IntakeCallTemplatesTranslation;
  interviewSimulations: InterviewSimulationsTranslation;
  maintenance: MaintenanceTranslation;
  meetings: MeetingsViewTranslation;
  processes: ProcessesTranslation;
  processTemplates: ProcessTemplatesTranslation;
  statistics: StatisticsTranslation;
  tags: TagsTranslation;
};

export const viewsTranslation: ViewsTranslation = {
  analysisRemarks: analysisRemarksViewTranslation,
  candidates: candidateDetailsTranslation,
  experienceCompanies: experienceCompaniesTranslation,
  intakeCallTemplates: intakeCallTemplatesTranslation,
  interviewSimulations: interviewSimulationsTranslation,
  maintenance: maintenanceTranslation,
  meetings: meetingsViewTranslation,
  processes: processesTranslation,
  processTemplates: processTemplatesTranslation,
  statistics: statisticsTranslation,
  tags: tagsTranslation,
};
